// If this list is updated, it must also be updated here:
// src/manta/app/model/user.rb
// https://github.com/DemystData/autodisco/blob/master/src/nemo/src/platform/views/Auth/SignUp.jsx
const forbiddenDomains = [
  "abc.com",
  "aim.com",
  "alice.it",
  "aliceadsl.fr",
  "aol.com",
  "arcor.de",
  "att.net",
  "bellsouth.net",
  "bigpond.com",
  "bigpond.net.au",
  "bluewin.ch",
  "blueyonder.co.uk",
  "bol.com.br",
  "centurytel.net",
  "charter.net",
  "chello.nl",
  "club-internet.fr",
  "comcast.net",
  "cox.net",
  "earthlink.net",
  "explorium.ai",
  "facebook.com",
  "free.fr",
  "freenet.de",
  "frontiernet.net",
  "gmail.com",
  "gmx.de",
  "gmx.net",
  "googlemail.com",
  "hetnet.nl",
  "home.nl",
  "hotmail.co.uk",
  "hotmail.com",
  "hotmail.de",
  "hotmail.es",
  "hotmail.fr",
  "hotmail.it",
  "icloud.com",
  "ig.com.br",
  "juno.com",
  "laposte.net",
  "libero.it",
  "live.ca",
  "live.co.uk",
  "live.com.au",
  "live.com",
  "live.fr",
  "live.it",
  "live.nl",
  "mac.com",
  "mail.com",
  "mail.ru",
  "me.com",
  "msn.com",
  "neuf.fr",
  "ntlworld.com",
  "optonline.net",
  "optusnet.com.au",
  "orange.fr",
  "outlook.com",
  "planet.nl",
  "pqr.com",
  "qq.com",
  "rambler.ru",
  "rediffmail.com",
  "rocketmail.com",
  "sbcglobal.net",
  "sfr.fr",
  "shaw.ca",
  "sky.com",
  "skynet.be",
  "sympatico.ca",
  "t-online.de",
  "telenet.be",
  "terra.com.br",
  "tin.it",
  "tiscali.co.uk",
  "tiscali.it",
  "uol.com.br",
  "verizon.net",
  "virgilio.it",
  "voila.fr",
  "wanadoo.fr",
  "web.de",
  "windstream.net",
  "xyz.com",
  "yahoo.ca",
  "yahoo.co.id",
  "yahoo.co.in",
  "yahoo.co.jp",
  "yahoo.co.uk",
  "yahoo.com.ar",
  "yahoo.com.au",
  "yahoo.com.br",
  "yahoo.com.mx",
  "yahoo.com.sg",
  "yahoo.com",
  "yahoo.de",
  "yahoo.es",
  "yahoo.fr",
  "yahoo.in",
  "yahoo.it",
  "yandex.ru",
  "ymail.com",
  "zonnet.nl"
];

// If this regular expression is updated, it must also be updated here:
// src/manta/config/initializers/devise_security_extension.rb
const validPasswordRegExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^0-9a-zA-Z])/;
const minimumPasswordLength = 8;

export function verifyPasswordValidity(password) {
  return validPasswordRegExp.test(password) && password.length >= minimumPasswordLength;
}

export function verifyEmailDomainValidity(emailDomain) {
  return !forbiddenDomains.includes(emailDomain);
}
